import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../assets/logo_mpp.png'


const _hoisted_1 = {
  id: "header-component",
  class: "pt-4"
}
const _hoisted_2 = { class: "d-flex align-items-stretch bg-black h-12-rem" }
const _hoisted_3 = {
  id: "header-logo-container",
  class: "me-3 pe-2 pt-1 w-12"
}
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SignIn = _resolveComponent("SignIn")!
  const _component_ShowSignedIn = _resolveComponent("ShowSignedIn")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          alt: "Marlyse Photo",
          id: "header-img-logo",
          class: "ms-2 mb-2 clickable",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickedHome && _ctx.clickedHome(...args))),
          src: _imports_0
        })
      ]),
      (!_ctx.isUserConnected)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_SignIn)
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_ShowSignedIn)
          ]))
    ])
  ]))
}